import { useState } from "react"
import { Link } from "react-router-dom"
import styles from "../../../styles/Form.module.css"

export default function KioskTemplateUsageNotice({
  isVisible,
  lockReason,
  formsUsingTemplate = [],
  organizations = [],
  includeTemplateAvailability = true,
}) {
  const [showDetails, setShowDetails] = useState(false)

  if (!isVisible) return null

  const kioskIntegrationLink = (
    <Link to="/library/kiosk" className={styles.templateKioskInlineLink}>
      Kiosk integration
    </Link>
  )

  if (lockReason === "check_failed") {
    return (
      <div className={styles.softErrorFieldMsg}>
        We could not verify Kiosk form usage right now. To avoid accidental
        configuration changes, {kioskIntegrationLink}
        {includeTemplateAvailability ? " and template availability" : ""} are
        temporarily locked.
      </div>
    )
  }

  const lockMessage = includeTemplateAvailability ? (
    <>Template availability and {kioskIntegrationLink} cannot be disabled.</>
  ) : (
    <>{kioskIntegrationLink} cannot be disabled.</>
  )

  // Group forms by their associated organization for easier display.
  const formsByOrganization = formsUsingTemplate.reduce((acc, form) => {
    const organizationId = form.soarOrganizationId || "unknown"

    if (!acc[organizationId]) {
      acc[organizationId] = []
    }

    acc[organizationId].push(form)
    return acc
  }, {})

  const organizationEntries = Object.entries(formsByOrganization)

  // Get the display label for an organization based on its ID.
  const getOrganizationLabel = (organizationId) => {
    const organization = organizations.find(
      (org) =>
        org.organization_id === organizationId ||
        org.organizationId === organizationId ||
        org.id === organizationId,
    )

    return (
      organization?.organization_name || organization?.name || organizationId
    )
  }

  return (
    <div className={styles.infoFieldMsg}>
      This template is currently used in Kiosk forms. {lockMessage}
      {formsUsingTemplate.length > 0 && (
        <div className={styles.templateKioskDetailsSection}>
          {showDetails && (
            <>
              <div className={styles.templateKioskDetailsHeading}>In use by:</div>
              <ul className={styles.templateKioskOuterList}>
                {organizationEntries.map(([organizationId, forms], orgIndex) => (
                  <li
                    key={organizationId || orgIndex}
                    className={styles.templateKioskListItem}
                  >
                    {getOrganizationLabel(organizationId)}
                    <ul className={styles.templateKioskInnerList}>
                      {forms.map((form, formIndex) => (
                        <li
                          key={form.id || form.name || formIndex}
                          className={styles.templateKioskListItem}
                        >
                          {form.name || form.id}
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </>
          )}
          <button
            type="button"
            onClick={() => setShowDetails((prev) => !prev)}
            aria-expanded={showDetails}
            className={`${styles.templateKioskToggleButton}${showDetails ? ` ${styles.templateKioskToggleButtonExpanded}` : ""}`}
          >
            {showDetails ? "Hide details" : "Show details"}
          </button>
        </div>
      )}
    </div>
  )
}
